import { withNamespaces } from 'react-i18next';
import {
    Card,
    CardBody,
    Col,
    Progress,
    Row,
} from 'reactstrap';

const VerificationOverview = ({
    overview,
    t,
}) => {
    const progress = overview.total ? Math.round((overview.verified / overview.total) * 100) : 0;
    const statistics = [
        { title: 'Total Bids', value: overview.total, color: 'primary' },
        { title: 'Verified', value: overview.verified, color: 'success' },
        { title: 'Action Required', value: overview.actionRequired, color: 'warning' },
        { title: 'Rejected', value: overview.rejected, color: 'danger' },
    ];

    return (
        <Card>
            <CardBody>
                <h5 className="mb-3">{t('Verification Overview')}</h5>

                <div className="d-flex justify-content-between align-items-start mb-2">
                    <span>
                        <i className="ri-information-line align-middle me-1" />
                        {t('Auto-verification in progress for all bids')}
                    </span>
                    <span className="text-primary">
                        {`${overview.verified} ${t('of')} ${overview.total} ${t('verified')}`}
                    </span>
                </div>

                <Progress className="mb-1" color="primary" value={progress} />

                <p className="text-end text-muted mb-3">
                    <small>{`${t('Estimated completion')}: ${overview.estimatedCompletion}`}</small>
                </p>

                <Row>
                    {statistics.map((statistic) => (
                        <Col key={statistic.title} xs="6" xl="3">
                            <div className={`border-start border-${statistic.color} ps-2 mb-2`}>
                                <h5 className={`text-${statistic.color} mb-0`}>
                                    {statistic.value}
                                </h5>
                                <small className="text-muted">{t(statistic.title)}</small>
                            </div>
                        </Col>
                    ))}
                </Row>
            </CardBody>
        </Card>
    );
};

export default withNamespaces()(
    VerificationOverview
);
